(function(){
  /* ---------- kleurstalen: cirkels in plaats van kleurnamen ---------- */
  var COLORS = {
    'lichtroze':'#f5c6d6','light pink':'#f5c6d6','rosa claro':'#f5c6d6','roze':'#ef8fb2','pink':'#ef8fb2',
    'rood':'#c8102e','red':'#c8102e',
    'koningsblauw':'#1f4fb5','royal':'#1f4fb5','royal blue':'#1f4fb5','blauw':'#2563c9','blue':'#2563c9',
    'marineblauw':'#1b2a4a','navy':'#1b2a4a','sport dark navy':'#1b2a4a','lichtblauw':'#b7d6ee','light blue':'#b7d6ee',
    'wit':'#ffffff','white':'#ffffff','blanco':'#ffffff','arctic white':'#ffffff',
    'zwart':'#111111','black':'#111111','negro':'#111111','deep black':'#111111',
    'bosgroen':'#1f5a3a','forest green':'#1f5a3a','dark green':'#1f5a3a',
    'groen':'#2f9e4a','green':'#2f9e4a','kelly green':'#2f9e4a','irish green':'#2f9e4a',
    'grijs':'#aeb2b7','grey':'#aeb2b7','gray':'#aeb2b7','sport grey':'#aeb2b7','heather grey':'#aeb2b7',
    'donkergrijs':'#4f545b','dark heather':'#4f545b','charcoal':'#4f545b','graphite heather':'#4f545b',
    'sand':'#d9c7a6','arena':'#d9c7a6','ash':'#d3d3d3','oranje':'#ec7a1f','orange':'#ec7a1f',
    'geel':'#f2c200','yellow':'#f2c200','gold':'#f2c200','heliconia':'#e0408a','maroon':'#6d1830','natural':'#efe6d2',
    'ocean':'linear-gradient(135deg,#6fa8dc,#2f6db3,#a9cdea)','amethyst':'linear-gradient(135deg,#b78bd6,#6f3fa0,#d8bdea)'
  };
  function injectSwatchCss(){
    if(document.getElementById('vk-swatch-css')) return;
    var s=document.createElement('style'); s.id='vk-swatch-css';
    s.textContent=
      'fieldset.vk-swatches{display:flex!important;flex-wrap:wrap;align-items:center;gap:12px!important}'+
      'fieldset.vk-swatches legend{flex:0 0 100%;margin-bottom:8px}'+
      'fieldset.vk-swatches .vk-cname{flex:0 0 100%;order:-1;font-weight:700;font-size:.95rem;margin:-2px 0 8px}'+
      'fieldset.vk-swatches label.vk-sw{position:relative;display:inline-flex!important;width:44px!important;min-width:44px!important;max-width:44px!important;height:44px!important;min-height:44px!important;padding:0!important;margin:0!important;border-radius:50%!important;border:1px solid #cfc8b8!important;background:var(--vk-sw,#ccc)!important;cursor:pointer;box-shadow:inset 0 0 0 3px #fff;transition:transform .15s,box-shadow .15s}'+
      'fieldset.vk-swatches label.vk-sw:hover{transform:scale(1.08)}'+
      'fieldset.vk-swatches label.vk-sw:has(input:checked){box-shadow:inset 0 0 0 3px #fff,0 0 0 2px #14110f!important}'+
      'fieldset.vk-swatches label.vk-sw .variant-option__button-label__pill{display:none!important}'+
      'fieldset.vk-swatches label.vk-sw .variant-option__button-label__text{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}'+
      'fieldset.vk-swatches label.vk-sw input{position:absolute;opacity:0;inset:0;width:100%;height:100%;margin:0;cursor:pointer}'+
      'fieldset.vk-swatches label.vk-sw:has(input[data-option-available="false"]){opacity:.4}'+
      'fieldset.vk-swatches label.vk-sw:has(input[data-option-available="false"])::after{content:"";position:absolute;left:8%;right:8%;top:50%;height:2px;background:#14110f;transform:rotate(-45deg)}'+
      /* maten: grote, makkelijke knoppen om aan te tikken */
      'fieldset.variant-option:not(.vk-swatches){display:flex!important;flex-wrap:wrap;gap:10px!important}'+
      'fieldset.variant-option:not(.vk-swatches) legend{flex:0 0 100%}'+
      'fieldset.variant-option:not(.vk-swatches) label{min-width:56px;min-height:48px;display:inline-flex;align-items:center;justify-content:center;border-radius:10px!important;font-weight:700}'+
      /* vaste koopbalk onderaan: pas zichtbaar als de gewone knop uit beeld is */
      '.vk-sticky-buy{transform:translateY(130%);transition:transform .25s ease}'+
      '.vk-sticky-buy.vk-show{transform:none}'+
      '.vk-sticky-buy{display:flex!important;align-items:center;justify-content:space-between;gap:12px}'+
      '.vk-sticky-buy button{min-height:48px;padding:0 22px;font-weight:800}'+
      /* winkelmandje: duidelijke Bancontact-knop, veilige betaalregel, geen kortingscode-veld */
      '.cart__checkout-button{background:#005498!important;color:#fff!important;border-color:#005498!important;min-height:52px}'+
      '.cart__checkout-button .button-text{font-size:0!important}'+
      '.cart__checkout-button .button-text::after{content:"Afrekenen met Bancontact";font-size:16px;font-weight:800}'+
      '.cart__ctas::after{content:"\\1F512  Betaal veilig met Bancontact, Visa, Mastercard, Maestro, Klarna, Apple Pay en Google Pay";order:1;text-align:center;font-size:12px;line-height:1.4;color:#555;padding:2px 4px}'+
      '.cart__ctas .additional-checkout-buttons{order:2}'+
      '.cart-actions{display:none!important}'+
      /* teller op het mandje in de onderbalk */
      '#vk-tabs a{position:relative}'+
      '#vk-tabs .vk-cb{position:absolute;top:2px;left:calc(50% + 6px);min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:#b3122a;color:#fff;font:800 11px/18px Inter,system-ui,sans-serif;text-align:center}';
    document.head.appendChild(s);
  }
  function applySwatches(){
    injectSwatchCss();
    document.querySelectorAll('fieldset.variant-option').forEach(function(fs){
      var inputs=fs.querySelectorAll('input[type="radio"]');
      if(!inputs.length) return;
      var name=(inputs[0].getAttribute('data-option-name')||'').toLowerCase();
      if(!/kleur|color|colour|couleur/.test(name)) return;
      var all=true;
      inputs.forEach(function(i){ if(!COLORS[(i.value||'').toLowerCase().trim()]) all=false; });
      if(!all) return;
      fs.classList.add('vk-swatches');
      inputs.forEach(function(i){
        var lab=i.closest('label'); if(!lab) return;
        lab.classList.add('vk-sw');
        lab.style.setProperty('--vk-sw', COLORS[(i.value||'').toLowerCase().trim()]);
        lab.title=i.value;
      });
      var cn=fs.querySelector('.vk-cname');
      if(!cn){ cn=document.createElement('div'); cn.className='vk-cname'; fs.insertBefore(cn, fs.querySelector('label')); }
      var cur=fs.querySelector('input:checked');
      cn.textContent=cur?cur.value:'';
    });
  }
  var swT; function swSoon(){ clearTimeout(swT); swT=setTimeout(applySwatches,60); }
  document.addEventListener('DOMContentLoaded',function(){ applySwatches(); new MutationObserver(swSoon).observe(document.body,{childList:true,subtree:true}); });
  document.addEventListener('change',swSoon);
  document.addEventListener('shopify:section:load',swSoon);
  setTimeout(applySwatches,800);

  /* ---------- teller op het mandje (onderbalk) ---------- */
  function updateCartBadge(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var a=document.querySelector('#vk-tabs a[href*="/cart"]'); if(!a) return;
      var b=a.querySelector('.vk-cb');
      if(!c.item_count){ if(b) b.remove(); return; }
      if(!b){ b=document.createElement('i'); b.className='vk-cb'; a.appendChild(b); }
      b.textContent=c.item_count;
    }).catch(function(){});
  }
  document.addEventListener('DOMContentLoaded',updateCartBadge);
  document.addEventListener('cart:update',function(){ setTimeout(updateCartBadge,300); });
  document.addEventListener('cart:change',function(){ setTimeout(updateCartBadge,300); });
  window.addEventListener('pageshow',updateCartBadge);

  function enhanceProduct(){
    if(!document.body.classList.contains('template-product') && !location.pathname.includes('/products/')) return;
    const form=document.querySelector('form[action*="/cart/add"]');
    if(!form || form.dataset.vkEnhanced) return;
    form.dataset.vkEnhanced='true';
    const submit=form.querySelector('button[type="submit"], input[type="submit"]');
    if(!submit) return;
    const note=document.createElement('div');
    note.className='vk-bulk-note';
    note.innerHTML='🚚 <strong>Gratis verzending vanaf €60</strong> in heel België. Binnen 5 werkdagen bij jou thuis.';
    submit.parentNode.insertBefore(note,submit);
    const trust=document.createElement('div');
    trust.className='vk-security-row';
    trust.innerHTML='<span>🔒 Veilig betalen</span><span>🦁 100% ontworpen in Vlaanderen</span><span>🚚 Heel België</span>';
    submit.parentNode.insertBefore(trust,submit.nextSibling);
    /* directe knop: toevoegen aan winkelmand en meteen naar de checkout (daar staat Bancontact als betaalmethode) */
    const buy=document.createElement('button');
    buy.type='button';
    buy.className='vk-buy-bancontact';
    buy.style.cssText='display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;width:100%;margin-top:10px;padding:14px 16px;border:0;border-radius:8px;background:#005498;color:#fff;font:800 1rem Inter,system-ui,sans-serif;cursor:pointer;min-height:56px';
    buy.innerHTML='<span>🔒 Direct afrekenen met Bancontact</span><small style="font-weight:600;font-size:.72rem;opacity:.9">of met kaart, Apple Pay, Klarna</small>';
    buy.addEventListener('click',function(){
      if(buy.disabled) return;
      buy.disabled=true; buy.style.opacity='.7';
      const fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){ window.location.href='/checkout'; })
        .catch(function(){ buy.disabled=false; buy.style.opacity='1'; submit.click(); });
    });
    submit.insertAdjacentElement('afterend',buy);
    const pay=document.createElement('div');
    pay.className='vk-pay-note';
    pay.style.cssText='margin-top:10px;font-size:.8rem;line-height:1.45;color:#555;text-align:center';
    pay.innerHTML='🔒 Betaal veilig met <strong>Bancontact</strong>, Visa, Mastercard, Maestro, American Express, Klarna, Apple Pay en Google Pay.';
    trust.parentNode.insertBefore(pay,trust.nextSibling);
    /* vaste koopbalk: prijs van de gekozen variant + knop die meteen in de winkelmand legt */
    document.querySelectorAll('.vk-sticky-buy').forEach(function(e){ e.remove(); });
    const sticky=document.createElement('div'); sticky.className='vk-sticky-buy';
    sticky.innerHTML='<span class="vk-sticky-buy__price"></span><button type="button">In winkelmand</button>';
    function curPrice(){
      var p=document.querySelector('product-price .price__sale:not(.price__hidden) .price-item--sale')||document.querySelector('product-price .price__regular .price');
      return p?p.textContent.replace(/\s+/g,' ').trim().slice(0,24):'';
    }
    function syncPrice(){ sticky.querySelector('.vk-sticky-buy__price').textContent=curPrice(); }
    syncPrice();
    document.addEventListener('change',function(){ setTimeout(syncPrice,350); });
    document.addEventListener('variant:update',function(){ setTimeout(syncPrice,150); });
    sticky.querySelector('button').addEventListener('click',function(){ submit.click(); });
    document.body.appendChild(sticky);
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        var e=en[0]; sticky.classList.toggle('vk-show', !e.isIntersecting && e.boundingClientRect.top<0);
      }).observe(submit);
    } else { sticky.classList.add('vk-show'); }
  }
  document.addEventListener('DOMContentLoaded',enhanceProduct);
  document.addEventListener('shopify:section:load',enhanceProduct);
  setTimeout(enhanceProduct,1200);
})();
